<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">Parámetros legales</h1>
    </div>

    <div class="table-container">
      <div class="table-header">
        <div class="d-flex justify-content-between align-items-center">
          <div></div>
          <div class="d-flex align-items-center">
            <button
              type="button"
              class="button-tooltip text-dark font-weight-bold mr-2"
              v-b-tooltip.hover
              title="Recargar"
              @click="loadData()"
            >
              <i class="ri-loop-right-line"></i>
            </button>
            <b-button
              :to="{ name: 'legal-parameter-create' }"
              variant="none"
              class="button button-primary"
            >Agregar año</b-button>
          </div>
        </div>
      </div>

      <div>
        <!-- Mobile -->
        <div class="custom-table-mobile d-xl-none">
          <section class="custom-table-mobile-header">
            <div><span>Año</span></div>
            <div><span>UIT</span></div>
            <div><span>Estado</span></div>
          </section>
          <div class="custom-table-mobile-body">
            <div class="custom-table-mobile-row" v-for="o in list" :key="o.id">
              <div class="custom-table-mobile-grid">
                <div>
                  <span :class="{ 'font-weight-bold': o.year === currentYear }">{{ o.year }}</span>
                </div>
                <div><span>{{ formatCurrency(o.uit) }}</span></div>
                <div>
                  <span :class="`badge ${getStatus(o.status).color}`">{{ getStatus(o.status).label }}</span>
                </div>
                <div>
                  <button
                    type="button"
                    class="border-0 bg-transparent"
                    @click="o.showMobileData = !o.showMobileData"
                  >
                    <i :class="o.showMobileData ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'"></i>
                  </button>
                </div>
              </div>
              <div v-if="o.showMobileData" class="pt-3">
                <ul class="list-unstyled p-0">
                  <li><span class="font-weight-medium mr-2">RMV:</span>{{ formatCurrency(o.rmv) }}</li>
                </ul>
              </div>
              <div class="custom-table-mobile-options mt-3">
                <router-link
                  :to="{ name: 'legal-parameter-edit', params: { id: o.id } }"
                  class="mx-3"
                >Editar</router-link>
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop -->
        <table class="custom-table w-100 d-none d-xl-table">
          <thead>
            <tr>
              <th>AÑO</th>
              <th class="text-right">UIT (S/)</th>
              <th class="text-right">RMV (S/)</th>
              <th>ESTADO</th>
              <th class="pr-md-3">OPCIONES</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="list.length === 0">
              <td colspan="5" class="text-center text-muted py-4">No se encontraron resultados.</td>
            </tr>
            <tr v-for="o in list" :key="o.id">
              <td class="pl-3" :class="{ 'font-weight-bold': o.year === currentYear }">
                {{ o.year }}
                <span v-if="o.year === currentYear" class="badge badge-info ml-2">Actual</span>
              </td>
              <td class="text-right pr-3">{{ formatCurrency(o.uit) }}</td>
              <td class="text-right pr-3">{{ formatCurrency(o.rmv) }}</td>
              <td class="cell-center pl-md-2">
                <span :class="`badge ${getStatus(o.status).color}`">{{ getStatus(o.status).label }}</span>
              </td>
              <td class="cell-center d_option pr-md-2 position-relative">
                <DropdownTable>
                  <template slot="dropdown-content">
                    <DropdownItem
                      text="Editar"
                      :to="{ name: 'legal-parameter-edit', params: { id: o.id } }"
                    />
                  </template>
                </DropdownTable>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-footer d-flex justify-content-end align-items-center">
        <div class="table-no-results" v-if="list.length === 0">
          <p class="m-0 px-3">No se encontraron resultados.</p>
        </div>
        <p v-else class="m-0 px-3 text-muted small">{{ list.length }} registro(s)</p>
      </div>
    </div>
  </div>
</template>

<script>
import { Alert, DropdownTable, DropdownItem } from "wize-admin";
import { LegalParameterService } from "@/core/services";

export default {
  components: { DropdownTable, DropdownItem },

  data() {
    return {
      list: [],
      currentYear: new Date().getFullYear(),
    };
  },

  methods: {
    async loadData() {
      try {
        await this.$store.dispatch("app/loading", true);
        const resp = await LegalParameterService.list();
        this.list = (resp.payload || []).map((item) => ({
          ...item,
          showMobileData: false,
        }));
      } catch (e) {
        console.error(e);
        Alert.error(e.errors ? e.errors.message : "Error al cargar los parámetros legales");
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },

    getStatus(key) {
      const map = {
        1: { label: "ACTIVO",     color: "badge-green"  },
        0: { label: "SUSPENDIDO", color: "badge-yellow" },
      };
      return map[parseInt(key)] || { label: String(key), color: "badge-secondary" };
    },

    formatCurrency(val) {
      if (val == null) return "-";
      return (
        "S/ " +
        parseFloat(val).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      );
    },
  },

  async created() {
    await this.loadData();
  },
};
</script>

<style lang="stylus">
@import '../../Areas/Styles/supplier-list';
</style>
